// extracted by mini-css-extract-plugin
export default {"hyphens":"R7895","projectMain":"k2_AB","projectTitle":"LT9sn R7895","projectFields":"M8S18","purpose":"aFQ7x","description":"IrxQD","supportButton":"hL5_t"};